import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '../common/Button';
import ShuttlrBrandMark from '../common/ShuttlrBrandMark';

export const LANDING_NAV_LINKS = [
  { href: '/#features', label: 'Features' },
  { href: '/#matchmaking', label: 'Matchmaking' },
  { href: '/#showcase', label: 'Clubs' },
  { href: '/#how-it-works', label: 'Sessions' },
];

const LandingNav = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    if (!mobileOpen) return undefined;
    document.body.style.overflow = 'hidden';
    const onKey = (e) => {
      if (e.key === 'Escape') setMobileOpen(false);
    };
    document.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey);
    };
  }, [mobileOpen]);

  return (
    <header className="sticky top-0 z-40 md:relative md:px-6 md:pt-6 lg:px-10">
      <div className="md:mx-auto md:max-w-app-shell">
        <div className="bg-gradient-to-r from-[#0a1628] via-slate-900 to-slate-800 text-white shadow-brand-lg md:rounded-2xl md:ring-1 md:ring-black/15">
          <div className="flex items-center gap-3 px-4 py-3 sm:px-6 sm:py-4">
            <a href="#top" className="flex items-center gap-2.5 shrink-0">
              <ShuttlrBrandMark />
              <span className="text-base font-bold leading-tight sm:text-xl">Shuttlr</span>
            </a>

            <nav className="hidden md:flex flex-1 items-center justify-center gap-1" aria-label="Landing">
              {LANDING_NAV_LINKS.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  className="rounded-lg px-3 py-2 text-sm text-white/80 hover:bg-white/10 hover:text-white focus:outline-none focus:ring-2 focus:ring-primary"
                >
                  {item.label}
                </a>
              ))}
            </nav>

            <div className="ml-auto flex items-center gap-1.5 sm:gap-2">
              <Button
                as={Link}
                to="/login"
                variant="primary"
                size="small"
                className="!h-9 !min-h-0 rounded-full px-3.5 font-semibold shadow-none md:hidden"
              >
                Log in
              </Button>
              <Button as={Link} to="/login" variant="nav" size="small" className="hidden md:inline-flex">
                Log in
              </Button>
              <Button as={Link} to="/signup" variant="primary" size="small" className="hidden md:inline-flex">
                Create Account
              </Button>
              <button
                type="button"
                className="inline-flex h-9 w-9 items-center justify-center rounded-full text-white hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-primary md:hidden"
                aria-label={mobileOpen ? 'Close menu' : 'Open menu'}
                aria-expanded={mobileOpen}
                onClick={() => setMobileOpen((open) => !open)}
              >
              {mobileOpen ? (
                <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              ) : (
                <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              )}
              </button>
            </div>
          </div>
        </div>
      </div>

      {mobileOpen && (
        <div className="fixed inset-0 z-50 md:hidden">
          <button
            type="button"
            className="absolute inset-0 bg-black/40"
            aria-label="Close menu"
            onClick={() => setMobileOpen(false)}
          />
          <div className="absolute inset-y-0 right-0 flex w-72 max-w-[85vw] flex-col bg-gradient-to-b from-[#0a1628] via-slate-900 to-slate-800 p-6 text-white shadow-brand-lg">
            <nav className="flex flex-col gap-1" aria-label="Landing mobile">
              {LANDING_NAV_LINKS.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  className="rounded-lg px-3 py-3 text-base hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-primary"
                  onClick={() => setMobileOpen(false)}
                >
                  {item.label}
                </a>
              ))}
            </nav>
            <div className="mt-6 flex flex-col gap-2">
              <Button as={Link} to="/login" variant="nav" className="w-full justify-center border border-white/25">
                Log in
              </Button>
              <Button as={Link} to="/signup" variant="primary" className="w-full justify-center">
                Create Account
              </Button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default LandingNav;
